import React from 'react';
import { useCalendarEvents } from './useCalendarEvents';
import CalendarItemCard from './CalendarItemCard';

type Props = {
  day?: number;
  month?: number;
  year?: number;
};

const CalendarEventsPopover = ({ day, month, year }: Props) => {
  const events = useCalendarEvents({
    day,
    month,
    year,
  });
  return (
    <React.Fragment>
      <h3>
        Events on {day}/{month}
      </h3>
      <div>
        {events.map(event => (
          <CalendarItemCard item={event} />
        ))}
      </div>
    </React.Fragment>
  );
};

export default CalendarEventsPopover;
